import {Hydra} from '../generic/hydra';

import {MotCleTranslationInterface} from './MotCleTranslation';
import {MotCle as MotCleBaseInterface} from '../../interface/api/MotCle';

export type MotCleInterface = MotCleBaseInterface;

export class MotCle extends Hydra implements MotCleInterface {

    id?: number | null;

    /* Tableau des traductions, typage strict car on doit forcément renvoyer l'objet
     */
    translations?: MotCleTranslationInterface[] | null;


    constructor(options: MotCleInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
